import React, { useCallback, useEffect, useState } from "react";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import LayersIcon from "@mui/icons-material/Layers";
import LayersClearIcon from "@mui/icons-material/LayersClear";
import SensorsIcon from "@mui/icons-material/Sensors";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import LocationSearchingIcon from "@mui/icons-material/LocationSearching";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import $ from "jquery";
import { fetchApi, main_url } from "../../helper/api";
import { getBase64, getCookie, renderSensorIcon } from "../../helper/function";
import NoImage from "../molecules/home/NoImage";
import { TextField, Tooltip } from "@mui/material";
import { connect } from "react-redux";
import { IsAlert } from "../atoms/IsAlert";
import ListSensor from "../molecules/popup/ListSensor";
import SyncIcon from "@mui/icons-material/Sync";
import ListCamera from "../molecules/popup/ListCamera";
import LayoutCanvas from "./layoutCanvas";
import TableLayout from "./TableLayout";
import DialogTurnOnSensor from "../molecules/popup/DialogTurnOnSensor";

$.Datatable = require("datatables.net");

export const ContentSensorMonitor = ({ dataIpc, idBridge, role }) => {
  const [state, setState] = useState({
    activeDrags: 0,
    deltaPosition: {
      x: 0,
      y: 0,
    },
    controlledPosition: {
      x: -400,
      y: 200,
    },
    image: null,
    imagePost: null,
    changePosition: false,
    dataListSensor: null,
    listSensor: null,
    listSensorSampleRate: {},
    layout: null,
    noIPC: "",
    namaLayoutBaru: "",
    open: false,
    openSensor: false,
    openIPC: false,
  });
  const [openDialogTurnOnSensor, setOpenDialogTurnOnSensor] = useState(false);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getData();
      getSensor();
    }
    return () => {
      isMounted = false;
    };
  }, []);

  const deleteData = async (id) => {
    const req = await fetchApi("api/Layout/" + id, "DELETE", true);
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      getData();
    } else {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "error",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
        }
      });
    }
  };

  const getData = async () => {
    // console.log("[IPC]", dataIpc.serialNumber);
    const req = await fetchApi(
      `api/Layout/${dataIpc?.serialNumber}`,
      "GET",
      true
    );
    const res = await req.json();
    const status = req.status;
    // console.log("RES DATA ", res.data);
    setState((current) => {
      return { ...current, layout: res.data };
    });
  };

  const getSensor = async () => {
    const req = await fetchApi(
      `api/Rtu/ipc/${dataIpc?.serialNumber}`,
      "GET",
      true
    );
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      let tempSensors = Object.entries(res?.data);
      let activeSensorList = {};
      // console.log("TEMP SENSORS", tempSensors);
      for (let i = 0; i < tempSensors.length; i++) {
        let isActive = false;
        let nameSensor;
        let activeSensor = [];
        tempSensors[i][1].map((item) => {
          if (item.isDetected) {
            activeSensor.push({
              ...item,
              isTurn: true,
              isCalibration: item?.isRecording ? true : false,
            });
            isActive = true;
            nameSensor = tempSensors[i][0];
          }
        });
        if (isActive) {
          activeSensorList[nameSensor] = activeSensor;
        }
      }
      // console.log("ACTIVE", activeSensorList);
      setState((current) => {
        return {
          ...current,
          listSensor: res?.data,
          listSensorSampleRate: activeSensorList,
        };
      });
    }
  };

  const getDataSensor = (sensorName) => {
    // console.log(sensorName);
    // var dataAccelerometer = dataSensor.filter((e) => e.sensor === sensorName)
    // return dataAccelerometer[0]
    setState((current) => {
      return { ...current, dataListSensor: sensorName };
    });
  };

  const handleImage = (e) => {
    const file = e.target.files[0];
    getBase64(file)
      .then((result) => {
        file["base64"] = result;
        // var base64 = result.replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
        setState((current) => {
          return { ...current, image: result, imagePost: file };
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleUpload = async () => {
    let formdata = new FormData();
    formdata.append("ipcSerialNumber", dataIpc.serialNumber);
    formdata.append("idBridge", idBridge);
    formdata.append("namaLayout", state?.namaLayoutBaru);
    formdata.append("file", state?.imagePost, state?.imagePost?.name);

    const tokene = getCookie("token");
    const header = {
      Authorization: `Bearer ${tokene}`,
    };
    const requestOptions = {
      method: "POST",
      headers: header,
      body: formdata,
      redirect: "follow",
    };

    const req = await fetch(`${main_url}/api/Layout`, requestOptions);
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      const elements = res.data.elements;
      Object.entries(state?.listSensor).map((f) => {
        f[1].map((e, i) => {
          let dataPush = {
            id: e.idSensor,
            data: {
              label: `${e.group.charAt(0)}${e.numberSensor}`,
            },
            type: "pinSensor",
            position: {
              x: 0,
              y: 0,
            },
          };
          elements.push(dataPush);
        });
      });
      const reqLayout = await fetchApi(
        `api/Layout/${dataIpc?.serialNumber}`,
        "GET",
        true
      );
      const resLayout = await reqLayout.json();
      const patokan = res.data._id;
      const cek = resLayout.data.filter((e) => e._id === patokan);
      if (cek.length > 0) {
        const id_layout = cek[0]._id;
        const dataPost = {
          elements: elements,
        };
        fetchApi(`api/Layout/elements/${id_layout}`, "POST", true, dataPost);
      }
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "success",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          // $(".close").click();
          getData();
        }
      });
    }
  };

  const deteksiSensor = async () => {
    const req = await fetchApi("api/Rtu/detect", "get", true);
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "success",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
        }
      });
    } else {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "error",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
        }
      });
    }
  };
  const resetSensor = async () => {
    const req = await fetchApi("api/Rtu/reset", "get", true);
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "success",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
        }
      });
    } else {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "error",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
        }
      });
    }
  };
  const matikanSemuaSensor = async (isTrue) => {
    const sensorList = [];
    state?.listSensor &&
      Object.entries(state?.listSensor).map((e, i) => {
        e[1].map((d, n) => {
          sensorList.push({ idSensor: d.idSensor });
        });
      });
    const data = {
      isSaveToDB: false,
      isZeroing: false,
      sensorTurn: sensorList,
    };
    const req = await fetchApi(
      `api/Rtu/${isTrue ? "off" : "on"}`,
      "POST",
      true,
      data
    );
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "success",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          // $(".close").click();
          getSensor();
          getData();
        }
      });
    } else {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "error",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
        }
      });
    }
  };

  const handleSync = async () => {
    const body = { ipcSerialNumber: dataIpc?.serialNumber };
    // console.log(body);
    const req = await fetchApi("api/Rtu/sync", "post", true, body);
    const res = await req.json();
    const status = req.status;
    if (status === 200) {
      console.log("success synchronize");
      window.location.reload();
    } else {
      console.log("failed sychronize!");
    }
  };

  const updatePositionSensor = async (data, id) => {
    if (data.length > 1) {
      let newMapPosition = [];
      data.map((item) => {
        let tempItem = { ...item };
        delete tempItem.data.sensorDetail;
        delete tempItem.style;
        delete tempItem.sensorDetail;
        newMapPosition.push(tempItem);
      });
      // console.log(newMapPosition);
      const body = { elements: newMapPosition };

      const req = await fetchApi(
        `api/Layout/elements/${id}`,
        "post",
        true,
        body
      );
      const res = await req.json();
      if (req.status === 200) {
        console.log("RESPONSE UPDATE MAP SENSOR", res);
        IsAlert.fire({
          title: "Sukses!",
          text: "Berhasil merubah posisi sensor",
          icon: "success",
          showCancelButton: false,
          focusConfirm: true,
          confirmButtonText: "OK",
        });
      } else {
        IsAlert.fire({
          title: "Gagal!",
          text: "Gagal merubah posisi sensor, coba beberapa saat lagi",
          icon: "warning",
          showCancelButton: false,
          focusConfirm: true,
          confirmButtonText: "OK",
        });
      }
    }
  };

  const handleDynamicTurnSensor = useCallback(async () => {
    let arraySampleRate = Object.entries(state?.listSensorSampleRate)?.map(
      (sensor) =>
        sensor[1]?.map((item) => {
          return {
            idSensor: item?.idSensor,
            isTurn: item?.isTurn,
            sampleRate: item?.sampleRate,
            isCalibration: item?.isCalibration,
          };
        })
    );
    let extractedSampleRate = [];
    for (let i = 0; i < arraySampleRate?.length; i++) {
      arraySampleRate[i]?.map((item) => extractedSampleRate?.push(item));
    }
    const body = {
      isSaveToDB: true,
      isZeroing: false,
      sensorTurn: extractedSampleRate,
    };
    // console.log("BODY: ", body);
    const req = await fetchApi(
      `api/Rtu/onDynamic/${dataIpc?.serialNumber}`,
      "POST",
      true,
      body
    );
    const res = await req?.json();
    IsAlert.fire({
      title: res.status,
      text: res.message,
      icon: req?.status === 200 ? "success" : "error",
      showCancelButton: false,
      focusConfirm: true,
      confirmButtonText: "OK",
      customClass: {
        confirmButton: "btn btn-close shadow-sm",
      },
    }).then(function (isConfirm) {
      if (isConfirm.isConfirmed) {
      }
    });
  }, [dataIpc?.serialNumber, state?.listSensorSampleRate]);

  const handleCheckTurnOnSensor = useCallback(
    (sensor, index, value) => {
      let newArrayValue = [...state?.listSensorSampleRate[sensor]];
      let newObjectTargetIsTurn = {
        ...state?.listSensorSampleRate[sensor][index],
        isTurn: value,
      };
      newArrayValue[index] = newObjectTargetIsTurn;
      setState((current) => {
        return {
          ...current,
          listSensorSampleRate: {
            ...current?.listSensorSampleRate,
            [sensor]: newArrayValue,
          },
        };
      });
    },
    [state?.listSensorSampleRate]
  );

  const handleCheckAllTurnOnSensor = useCallback(
    (value) => {
      // setCheckedAll(value);
      let data = { ...state?.listSensorSampleRate };
      for (const key in data) {
        for (let i = 0; i < data[key].length; i++) {
          data[key][i].isTurn = value;
        }
      }
      // console.log("added data", data);
      setState((current) => {
        return {
          ...current,
          listSensorSampleRate: data,
        };
      });
    },
    [state?.listSensorSampleRate]
  );

  const handleSetSampleRateChange = useCallback(
    (sensor, index, value) => {
      let newArrayValue = [...state.listSensorSampleRate[sensor]];
      let newObjectTargetValue = {
        ...state.listSensorSampleRate[sensor][index],
        sampleRate: value,
      };
      newArrayValue[index] = newObjectTargetValue;
      setState((current) => {
        return {
          ...current,
          listSensorSampleRate: {
            ...current.listSensorSampleRate,
            [sensor]: newArrayValue,
          },
        };
      });
    },
    [state.listSensorSampleRate]
  );

  const RenderContent = () => {
    return (
      <div>
        <DialogTurnOnSensor
          open={openDialogTurnOnSensor}
          onClose={() => {
            setOpenDialogTurnOnSensor(false);
          }}
          listSensorSampleRate={
            Object.entries(state?.listSensorSampleRate) ?? []
          }
          callbackTurnOnSensor={() => handleDynamicTurnSensor()}
          // callbackCheckCalibration={(sensor, index, value) =>
          //   handleCheckCalibration(sensor, index, value)
          // }
          // callbackCheckAllCalibration={(checked) => {
          //   handleCheckCalibrationAll(checked);
          // }}
          callbackCheckTurnOnSensor={(sensor, index, value) => {
            handleCheckTurnOnSensor(sensor, index, value);
          }}
          callbackCheckAllTurnOnSensor={(checked) => {
            handleCheckAllTurnOnSensor(checked);
          }}
          callbackSelectSampleRate={(sensor, index, value) =>
            handleSetSampleRateChange(sensor, index, value)
          }
        />
        <ListCamera dataIpc={dataIpc} />
        <ListSensor data={state?.dataListSensor} />
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="mb-0">Pemantauan Sensor</h1>
          <div>
            {role && (role === "enginer" || role === "Super User") && (
              <div className="d-flex justify-content-end align-items-center">
                <Tooltip title="Sinkronkan" placement="top">
                  <div
                    className="btn rounded-round p-2 bg-success"
                    onClick={handleSync}
                  >
                    <SyncIcon />
                  </div>
                </Tooltip>
                <div className="mx-3">
                  <span className="text-muted" style={{ fontSize: "40px" }}>
                    I
                  </span>
                </div>
                <div>
                  <FormGroup>
                    <FormControlLabel
                      className="m-0"
                      control={
                        <Switch
                          onChange={(event) =>
                            setState((current) => {
                              return {
                                ...current,
                                changePosition: event.target.checked,
                              };
                            })
                          }
                        />
                      }
                      label="Ubah Titik Sensor"
                    />
                  </FormGroup>
                </div>
                <div className="mx-3">
                  <span className="text-muted" style={{ fontSize: "40px" }}>
                    I
                  </span>
                </div>
                <div>
                  <button
                    className="btn btn-info w-100 d-flex align-items-center justify-content-center px-2 mx-0"
                    data-toggle="modal"
                    data-target={`#modalCamera-${dataIpc.serialNumber}`}
                  >
                    <i className="las la-camera"></i>
                  </button>
                </div>
                <div className="mx-3">
                  <span className="text-muted" style={{ fontSize: "40px" }}>
                    I
                  </span>
                </div>
                <div>
                  <button
                    className="btn btn-dark w-100 d-flex align-items-center justify-content-center px-1"
                    data-toggle="modal"
                    data-target={`#modalSettingSensor-${dataIpc.serialNumber}`}
                  >
                    <i className="las la-cog"></i>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="row mt-4">
          {state?.listSensor &&
            Object.entries(state.listSensor).map((e, i) => {
              return (
                <div
                  className={
                    Object.entries(state.listSensor).length > 1
                      ? "col-lg-4"
                      : "col-lg"
                  }
                  key={i}
                >
                  <span
                    onClick={() => getDataSensor(e[1])}
                    className={`shortcut position-relative cursor-pointer shortcut-hijau`}
                    data-toggle="modal"
                    data-target="#listSensor_modal"
                  >
                    <div className="card z-2 bg-white p-2  rounded-banget shadow d-flex justify-content-between align-items-center flex-row">
                      <img
                        src={renderSensorIcon(e[0])}
                        alt="sensor"
                        width={40}
                        height={40}
                      />
                      <div className="d-flex align-items-center w-100 flex-row">
                        <div className="mx-2">
                          <p
                            className="mb-0"
                            style={{ fontSize: "18px", fontWeight: 600 }}
                          >
                            {e[0]}
                          </p>
                          <p className="mb-0">{e[1].length} Sensor</p>
                        </div>
                      </div>
                      <div>
                        <AvatarGroup total={e[1].length}>
                          {e[1].map((d, n) => {
                            if (n < 3) {
                              return (
                                <Avatar
                                  key={n}
                                  sx={{ backgroundColor: "#ccc" }}
                                >
                                  {d.group.charAt(0)}
                                  {d.numberSensor}
                                </Avatar>
                                // <Avatar key={i} sx={{ backgroundColor: d.active ? "#5BC673" : "#d9534f" }}>{d.sensor_id}</Avatar>
                              );
                            }
                          })}
                        </AvatarGroup>
                      </div>
                    </div>
                  </span>
                </div>
              );
            })}
        </div>

        <ul className="nav nav-tabs mb-3" id="pills-tab" role="tablist">
          {state.layout &&
            state.layout.map((e, i) => {
              if (i === 0) {
                return (
                  <li className="nav-item" role="presentation" key={i}>
                    <button
                      className="nav-link active"
                      data-toggle="pill"
                      data-target={`#layout_${e._id}`}
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      {e.namaLayout}
                    </button>
                  </li>
                );
              } else {
                return (
                  <li key={i} className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      data-toggle="pill"
                      data-target={`#layout_${e._id}`}
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      {e.namaLayout}
                    </button>
                  </li>
                );
              }
            })}
        </ul>

        <div className="d-flex flex-lg-row flex-column justify-content-start align-items-center  mb-3">
          <span>Keterangan warna : </span>
          <div className="d-flex align-items-center mx-lg-2">
            <div>
              <div className="legend legend-hijau"></div>
            </div>
            <span className="ml-1">Sensor Hidup</span>
          </div>
          <div className="d-flex align-items-center mx-lg-2">
            <div>
              <div className="legend legend-merah"></div>
            </div>
            <span className="ml-1">Sensor Mati</span>
          </div>
          <div className="d-flex align-items-center mx-lg-2">
            <div>
              <div className="legend legend-kuning"></div>
            </div>
            <span className="ml-1">Sensor Tidak Terdeksi</span>
          </div>
        </div>

        <div className="tab-content" id="pills-tabContent">
          {state?.layout &&
            state?.layout.map((e, i) => {
              return (
                <div
                  key={i}
                  className={`tab-pane fade ${i === 0 && "show active"}`}
                  id={`layout_${e._id}`}
                  role="tabpanel"
                >
                  <div className="bg-white rounded-banget shadow px-2 pb-4 pt-2">
                    <LayoutCanvas
                      id={e._id}
                      layout={e.urlImage}
                      elements={e.elements}
                      isDraggable={state.changePosition}
                      callbackNewPosition={(data, id) =>
                        updatePositionSensor(data, id)
                      }
                    />
                  </div>
                </div>
              );
            })}
        </div>

        <div
          className="modal fade"
          id={`modalTambahLayout-${dataIpc.serialNumber}`}
          tabIndex={-1}
          aria-hidden="true"
          style={{ overflow: "scroll" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Tambah Layout</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row mb-3">
                  <div className="col-lg-8">
                    <TextField
                      onChange={(e) =>
                        setState((current) => {
                          return { ...current, namaLayoutBaru: e.target.value };
                        })
                      }
                      value={state?.namaLayoutBaru}
                      className="w-100"
                      label="Nama Layout"
                      variant="standard"
                      autoComplete="off"
                    />
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <label
                        htmlFor="uploadImage"
                        className="btn btn-success d-flex align-items-center"
                      >
                        <i className="las la-plus f-19 mr-2"></i>
                        <span>Upload Gambar</span>
                      </label>
                      <input
                        type="file"
                        id="uploadImage"
                        className="input_file_hide"
                        onChange={handleImage}
                      />
                    </div>
                  </div>
                </div>
                {state?.image ? (
                  <img
                    src={state?.image}
                    className="w-100"
                    style={{ height: "425px", objectFit: "contain" }}
                    alt="img"
                  />
                ) : (
                  <NoImage />
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={handleUpload}
                >
                  Simpan
                </button>
                <button
                  type="button"
                  className="btn btn-light"
                  data-dismiss="modal"
                >
                  Batal
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="modalDeleteLayout"
          tabIndex={-1}
          aria-labelledby="modalDeleteLayoutLabel"
          aria-hidden="true"
          style={{
            overflow: "scroll",
          }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title" id="modalDeleteLayoutLabel">
                  Hapus Layout
                </h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <TableLayout
                  data={state.layout}
                  callbackData={(id) => deleteData(id)}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light"
                  data-dismiss="modal"
                >
                  Batal
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id={`modalSettingSensor-${dataIpc.serialNumber}`}
          tabIndex={-1}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-sm">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Pengaturan</h5>
                <button
                  type="button"
                  className="close closeModalSetting"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body px-0">
                <List
                  sx={{ width: "100%", bgcolor: "background.paper" }}
                  component="nav"
                  aria-labelledby="nested-list-subheader"
                  subheader={
                    <ListSubheader
                      component="div"
                      id="nested-list-subheader"
                    ></ListSubheader>
                  }
                >
                  {/* <ListItemButton>
                    <ListItemIcon>
                      <DraftsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Drafts" />
                  </ListItemButton> */}
                  <ListItemButton
                    onClick={() =>
                      setState((current) => {
                        return { ...current, open: !current?.open };
                      })
                    }
                  >
                    <ListItemIcon>
                      <LayersIcon />
                    </ListItemIcon>
                    <ListItemText primary="Layout" />
                    {state?.open ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={state?.open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        data-toggle="modal"
                        data-target={`#modalTambahLayout-${dataIpc.serialNumber}`}
                        onClick={() => $(".closeModalSetting").click()}
                      >
                        <ListItemIcon>
                          <AddPhotoAlternateIcon />
                        </ListItemIcon>
                        <ListItemText primary="Tambah Layout" />
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        data-toggle="modal"
                        data-target="#modalDeleteLayout"
                        onClick={() => $(".closeModalSetting").click()}
                      >
                        <ListItemIcon>
                          <LayersClearIcon />
                        </ListItemIcon>
                        <ListItemText primary="Hapus Layout" />
                      </ListItemButton>
                    </List>
                  </Collapse>
                  <ListItemButton
                    onClick={() =>
                      setState((current) => {
                        return { ...current, openSensor: !current.openSensor };
                      })
                    }
                  >
                    <ListItemIcon>
                      <SensorsIcon />
                    </ListItemIcon>
                    <ListItemText primary="Sensor" />
                    {state?.openSensor ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={state?.openSensor} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => {
                          deteksiSensor();
                          $(".closeModalSetting").click();
                        }}
                      >
                        <ListItemIcon>
                          <LocationSearchingIcon />
                        </ListItemIcon>
                        <ListItemText primary="Deteksi Sensor" />
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => {
                          resetSensor();
                          $(".closeModalSetting").click();
                        }}
                      >
                        <ListItemIcon>
                          <RestartAltIcon />
                        </ListItemIcon>
                        <ListItemText primary="Reset Sensor" />
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => {
                          // matikanSemuaSensor(false)
                          setOpenDialogTurnOnSensor(true);
                        }}
                      >
                        <ListItemIcon>
                          <PowerSettingsNewIcon />
                        </ListItemIcon>
                        <ListItemText primary="Hidupkan Semua Sensor" />
                      </ListItemButton>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => matikanSemuaSensor(true)}
                      >
                        <ListItemIcon>
                          <PowerSettingsNewIcon />
                        </ListItemIcon>
                        <ListItemText primary="Matikan Semua Sensor" />
                      </ListItemButton>
                    </List>
                  </Collapse>
                  {/* <ListItemButton
                    onClick={() =>
                      this.setState({ openIPC: !this.state.openIPC })
                    }
                  >
                    <ListItemIcon>
                      <SensorsIcon />
                    </ListItemIcon>
                    <ListItemText primary="IPC" />
                    {this.state.openIPC ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse
                    in={this.state.openIPC}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        data-toggle="modal"
                        data-target="#modalTambahIPC"
                        onClick={() => $(".closeModalSetting").click()}
                      >
                        <ListItemIcon>
                          <PowerSettingsNewIcon />
                        </ListItemIcon>
                        <ListItemText primary="Tambah IPC" />
                      </ListItemButton>
                    </List>
                  </Collapse> */}
                </List>
              </div>
              <div className="modal-footer">
                {/* <button
                  type="button"
                  className="btn btn-danger"
                  onClick={this.handleUpload}
                >
                  Hapus
                </button> */}
                <button
                  type="button"
                  className="btn btn-light"
                  data-dismiss="modal"
                >
                  Batal
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return RenderContent();
};

const mapState = (state) => {
  return {
    _dataProfile: state.dataProfile,
  };
};

const actionCreators = (dispatch) => {
  return {};
};

export default connect(mapState, actionCreators)(ContentSensorMonitor);
